import { getPartsInAppTz, todayYmd } from '../../../utils/appTimezone';

export function consultationYmd(consultation) {
  const p = getPartsInAppTz(consultation?.consultation_date);
  if (!p) return '';
  return `${p.year}-${p.month}-${p.day}`;
}

export function isConsultationToday(consultation, today = todayYmd()) {
  const ymd = consultationYmd(consultation);
  return ymd !== '' && ymd === today;
}
